module.exports = __webpack_public_path__ + "static/menu-ikeda-sengyo-min2-ec5621dc9e83b8d99a20b87a2de70cbc.jpg";